module.exports = {"pipeline":{"name":"pipeline-npsQuestion","title":"NPS评分题","type":"qs-mark","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-npsQuestion/package.json
// module id = 560
// module chunks = 2